// /resources/js/app/modules/v2/app/V2StateManager.js

/**
 * @class V2StateManager
 * A dedicated class to hold and manage the reactive state for the V2 application.
 * This acts as the single source of truth, ensuring that data is consistent
 * across different parts of the application. It is managed by the ActionHandler.
 */
class V2StateManager {
    constructor() {
        // --- Core Data State ---
        this.streams = [];
        this.signals = [];
        this.pagination = {};
        this.optimisticSignals = [];

        // --- UI & Interaction State ---
        this.isLoading = false;
        this.activeStreamSlug = null;
        this.viewMode = localStorage.getItem('v2_view_mode') || 'card';
        this.sort = { by: 'call_timestamp', dir: 'desc' };
        this.showUnlockedOnly = false;

        // --- Polling & Live Update State ---
        this.isInitialLoad = true;
        this.lastStatusToken = null;
        this.streamUpdateCounts = {};
        this.originalPageTitle = document.title; 
        this.streamTotalCounts = {};
    }
}

export const v2StateManager = new V2StateManager();